import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const AdminRoute = ({ children }) => {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  // التحقق من أن المستخدم مسجل دخول وله دور admin
  if (!user || !user.roles?.some(role => role.name === 'admin')) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default AdminRoute;